import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  baseUrl = environment.baseUrl;

  constructor(
    private http:HttpClient,) { }

  get_orders() {
    return this.http.get(this.baseUrl + '/get_orders');
  }

  get_return_orders() {
    return this.http.get(this.baseUrl + '/get_return_orders');
  }

  get_shipped_orders() {
    return this.http.get(this.baseUrl + '/get_shipped_orders');
  }

  get_new_orders() {
    return this.http.get(this.baseUrl + '/get_new_orders');
  }

  get_order_details(order_id){
    return this.http.get(this.baseUrl + '/get_order_details/' + order_id);
  }

  get_order_status_master(){
    return this.http.get(this.baseUrl + '/get_order_status_master');
  }

  update_order_status(formData: any){
    return this.http.post(this.baseUrl + '/update_order_status',{
      id: formData.id,
      order_status: formData.order_status
    });
  }

  add_order_item(order_data:any, product_data){
    return this.http.post(this.baseUrl + '/add_order_item/' + order_data.id, product_data)
  }

  update_order_items(order_data:any, orderItems){
    return this.http.post(this.baseUrl + '/update_order_items/' + order_data.id,{
      order_data : order_data,
      order_items: orderItems
    })
  }

  order_assigned_for_delivery(orderList, deliveryVehicleId, orderStatus){
    return this.http.post(this.baseUrl + '/order_assigned_for_delivery',{
      order_list: orderList,
      delivery_vehicle_id: deliveryVehicleId,
      order_status: orderStatus
    });
  }

  get_delivery_orders(veh_id) {
    return this.http.get(this.baseUrl + '/get_delivery_orders/' + veh_id);
  }

  order_shipped(orderList, orderStatus){
    return this.http.post(this.baseUrl + '/order_shipped',{
      order_list: orderList,
      order_status: orderStatus
    });
  }


  get_ready_for_shipment_orders(veh_id) {
    return this.http.get(this.baseUrl + '/get_ready_for_shipment_orders/' + veh_id);
  }

  generate_order_bill(orderList, orderStatus){
    return this.http.post(this.baseUrl + '/generate_order_bill',{
      order_list: orderList,
      order_status: orderStatus
    });
  }

  get_bill_generated_orders(veh_id) {
    return this.http.get(this.baseUrl + '/get_bill_generated_orders/' + veh_id);
  }

  update_out_of_delivery(orderList, orderStatus){
    return this.http.post(this.baseUrl + '/update_out_of_delivery',{
      order_list: orderList,
      order_status: orderStatus
    });
  }
  
}
